import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowRightIcon = createIconComponent(
  'ArrowRightIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 11.9999H21M21 11.9999L14 5M21 11.9999L14 18.9999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
